import React, { createContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { api } from '~/services/api'

export const TipContext = createContext()

export function TipProvider({ children }) {
    const [tips, setTips] = useState({})
    const [codigo, setCodigo] = useState('')

    const history = useHistory()

    history.listen(() => {
        setCodigo('')
    })

    async function loadTips() {
        const response = await api.get('tips_form', {
            params: {
                identificador_form: codigo
            }
        })

        if(!response) {
            return
        }

        setTips({
            formulario: response.texto,
            campos: response.campos.map(campo => ({
                campo: campo.nome,
                texto: campo.texto
            }))
        })
    }

    useEffect(() => {
        if(codigo) {
            loadTips()
        } else {
            setTips({})
        }
    }, [codigo])

    return (
        <TipContext.Provider 
            value={{
                setCodigo,
                tips
            }}
        >
            {children}
        </TipContext.Provider>
    )
}
